import { useEffect, useState } from "react";
import { Sparkles, Check, Trash2, User, MapPin, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { useMasters } from "./MastersContext";

export function AutoFiledSection() {
  const { loadAutoFiled, confirmAutoFiled, deleteAutoFiled } = useMasters();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  async function load() {
    setLoading(true);
    try { setItems(await loadAutoFiled()); }
    catch { /* ignore */ }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function confirm(it) {
    try { await confirmAutoFiled(it.kind, it.id); setItems((p) => p.filter((x) => !(x.kind === it.kind && x.id === it.id))); window.dispatchEvent(new Event("auto-filed-reviewed")); toast.success("Kept"); }
    catch { toast.error("Failed"); }
  }
  async function remove(it) {
    try { await deleteAutoFiled(it.kind, it.id); setItems((p) => p.filter((x) => !(x.kind === it.kind && x.id === it.id))); window.dispatchEvent(new Event("auto-filed-reviewed")); toast.success("Removed"); }
    catch { toast.error("Failed"); }
  }

  if (!loading && items.length === 0) return null;

  return (
    <section className="lg:col-span-2" data-testid="auto-filed-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-[#2B5FB3]" /><div className="section-title mb-0">Auto-filed from documents</div><span className="text-[11px] text-[#68665E]">(review entries the parser added under a company)</span></div>
        <button className="btn-ghost text-xs" onClick={load} disabled={loading} data-testid="auto-filed-refresh"><RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} /></button>
      </div>
      <div className="card-surface divide-y divide-[#F0EDE5]">
        {items.map((it) => (
          <div key={`${it.kind}-${it.id}`} className="flex items-center justify-between px-4 py-2.5 gap-3" data-testid={`auto-filed-row-${it.id}`}>
            <div className="flex items-start gap-2 min-w-0">
              {it.kind === "contact" ? <User className="w-4 h-4 text-[#68665E] mt-0.5 shrink-0" /> : <MapPin className="w-4 h-4 text-[#68665E] mt-0.5 shrink-0" />}
              <div className="min-w-0">
                <div className="text-sm font-medium text-[#1A1A18] truncate">{it.primary}</div>
                <div className="text-[11px] text-[#68665E] truncate">{[it.company_name, it.secondary].filter(Boolean).join(" · ")}</div>
              </div>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <button className="btn-secondary !py-1 text-xs" onClick={() => confirm(it)} data-testid={`auto-filed-keep-${it.id}`}><Check className="w-3.5 h-3.5" /> Keep</button>
              <button className="text-[#8A2526] px-2" onClick={() => remove(it)} data-testid={`auto-filed-delete-${it.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
